import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators/custom-element.js';
import '@rhds/elements/rh-badge/rh-badge.js';
import '@rhds/elements/rh-cta/rh-cta.js';
import './rhpt-trial-row-info.js';

import styles from './rhpt-trial-row.css';

/**
 * Trial Row
 * @slot - Place element content here
 */
@customElement('rhpt-trial-row')
export class RhptTrialRow extends LitElement {
  static readonly styles = [styles];

  #ctaClickHandler() {
    this.querySelector('rhpt-trial-row-info')
      ?.shadowRoot?.querySelector<any>('rh-dialog')
      ?.showModal();
      
      requestAnimationFrame(() => {
        const dialogElement = this.querySelector('rhpt-trial-row-info')
        ?.shadowRoot?.querySelector<any>('rh-dialog');
        const dialogFocusTrapStart = dialogElement.querySelector('#dialogFocusTrapStart');
      
          if (dialogFocusTrapStart) {
              dialogFocusTrapStart.focus({ preventScroll: true });
          }
      });
  }

  protected firstUpdated(_changedProperties: Map<PropertyKey, unknown>): void {
    this.#updateAnalytics();
    this.trimCtas();
  }

  /**
   * Remove extra whitespace around anchor tags
   */
  public trimCtas() {
    for (const cta of this.querySelectorAll('[slot="cta"], rh-cta a')) {
      if (cta) {
        cta.innerHTML = cta.innerHTML.trim();
      }
    }
  }

  /**
   * Transfer analytics-category to details button
   */
  #updateAnalytics(): void {
    const ctaBtn = this.querySelector('[slot="cta"]');
    const detailsBtn = this.shadowRoot?.querySelector('#trial-details');
    if (!detailsBtn || !ctaBtn) { return; }

    const category = ctaBtn.getAttribute('data-analytics-category');
    if (!category) { return; }

    detailsBtn.setAttribute('data-analytics-category', category);
  }

  render() {
    return html`
      <div part="base">
        <div class="product-info">
          <div class="product-title">
            <div class="product-logo">
              <slot part="logo" name="logo"></slot>
            </div>
            <slot part="title" name="title"></slot>
          </div>
          <div class="product-description">
            <slot part="description" name="description"></slot>
          </div>
        </div>
        <div class="product-actions">
          <div part="cta">
            <rh-cta variant="primary">
              <slot name="cta"></slot>
            </rh-cta>
          </div>

          <slot
            part="info-trigger"
            name="info-trigger"
            @click=${this.#ctaClickHandler}
          >
            <rh-cta variant="secondary">
              <a href="#trial-details" id="trial-details" data-analytics-linktype="cta" data-analytics-text="Trial details">
                <slot part="info-trigger-text" name="info-trigger-text"
                  >Trial details</slot
                >
              </a>
            </rh-cta>
          </slot>
        </div>
      </div>
      <slot part="info" name="info"></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'rhpt-trial-row': RhptTrialRow;
  }
}
